import { NotificationBase } from 'src/app/shared/services/notification/notification-base';
import { JobDetail } from '../../models/gql/job-detail.model';

export class NotificationFlexJob extends NotificationBase {
  process(): void {
    this.showAlert();
  }

  protected async viewNotification() {
    if (this.item && this.item.id) {
      try {
        const res: JobDetail = await this.jobsService.getPostedJobDetailsById(this.item.id);
        if (res) {
          const job = res;
          this.navigate(job);
        }
      } catch (error) {
        console.error(error);
      }
    }
  }

  private navigate(job) {
    let jobStatus;
    if (this.accountService.userIs('carer')) {
      jobStatus = job?.status?.workerStatus === 'accepted' ? 'booked' : 'open';
    } else {
      jobStatus = job?.status?.clientStatus === 'fulfilled' ? 'booked' : 'open';
    }
    this.navCtrl.navigateForward(
      `/flex/jobs/${jobStatus}/${this.accountService.getUser()?.custom['account_type']?.toLowerCase()}/${this.item.id}`,
    );
  }
}
